import { render, staticRenderFns } from "./registrationDialog1.vue?vue&type=template&id=1da6bb5d&scoped=true&"
import script from "./registrationDialog1.vue?vue&type=script&lang=js&"
export * from "./registrationDialog1.vue?vue&type=script&lang=js&"
import style0 from "./registrationDialog1.vue?vue&type=style&index=0&id=1da6bb5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da6bb5d",
  null
  
)

export default component.exports